export default class StringUtils {

  public static isValidJSONString(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  public static abbreviate(text, lim = 20, useDots=true) {
    if (text.length <= lim) return text;
    return text.slice(0, lim) + (useDots? "..." : '');
  }
}
